/**
 * Puerto Rico アクション選択 Move
 * @see docs/specifications/logic/puerto_rico/phase_03_select_actions_override.md
 */

import { INVALID_MOVE } from 'boardgame.io/core';
import { debug } from '../../utils/debug';
import type { Ctx } from 'boardgame.io';
import type { PuertoRicoGameState, PuertoRicoActionType } from '../../types';
import { validateSelectAction, validateSkipAction } from '../validators/selectActionsPuertoRicoValidator';
import { createSkipAction } from './common/skipAction';

/** アクション選択コスト */
const ACTION_SELECTION_COST = 5;

/**
 * Puerto Rico 専用アクション選択 Move
 *
 * 利用可能なアクション:
 * - ENGINEER: 線路を4枚まで配置可能（通常3枚）
 * - LOCOMOTIVE: 機関車レベル+1（即座実行）
 *
 * @param G - ゲーム状態
 * @param ctx - Boardgame.io コンテキスト
 * @param action - 選択するアクション
 * @returns void | INVALID_MOVE
 */
export function selectActionPuertoRico(
  { G, ctx }: { G: PuertoRicoGameState; ctx: Ctx },
  action: PuertoRicoActionType
): void | typeof INVALID_MOVE {
  const playerId = ctx.currentPlayer;

  // バリデーション
  const validation = validateSelectAction(G, playerId, action);
  if (!validation.valid) {
    debug.log(`[selectActionPuertoRico] Validation failed: ${validation.errorMessage}`);
    return INVALID_MOVE;
  }

  const player = G.players[playerId];

  // 1. $5を支払う
  player.cash -= ACTION_SELECTION_COST;

  // 2. アクション選択を記録
  player.selectedAction = action;

  // 3. 即座実行アクション（LOCOMOTIVE）
  if (action === 'LOCOMOTIVE') {
    player.locomotiveLevel += 1;
    debug.log(`[selectActionPuertoRico] LOCOMOTIVE: Lv${player.locomotiveLevel - 1} -> Lv${player.locomotiveLevel}`);
  }

  debug.log(`[selectActionPuertoRico] Player ${playerId} selected ${action}, paid $5 (remaining: $${player.cash})`);

  // 4. アクション選択完了フラグを設定
  G.isActionSelectionComplete = true;
}

/**
 * アクション選択スキップ Move（共通モジュール使用）
 */
export const skipAction = createSkipAction<PuertoRicoGameState>({
  validate: (G, playerId) => {
    const validation = validateSkipAction(G, playerId);
    return { valid: validation.valid, error: validation.errorMessage };
  },
  onComplete: (G) => {
    G.isActionSelectionComplete = true;
  }
});
